import { Card, CardContent, Box } from "@mui/material";
import NavAccount from "./NavAccount";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const Account = () => {
    const { isAuth } = useSelector(state => state.user)
    const navigate = useNavigate();

    
    useEffect(() => {
        if (!isAuth) {
            navigate("/", { replace: true }); // редирект на главную
        }
    }, [isAuth, navigate]);

    return (
        <Card>
            <CardContent>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="stretch"
                    gap={2}
                    minHeight="50vh"
                >
                    <NavAccount />
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={2}
                        flexGrow={1}
                        p={2}
                    >
                        <Outlet />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}

export default Account;